let defaultUrl = 'https://storage.hidreamai.com/image/'
export const defaultSnapshot = '?x-oss-process=video/snapshot,t_3000,f_jpg,w_768';
export const defaultSnapshotTimer = '?x-oss-process=video/snapshot,t_2500,f_jpg,w_768';
export const defaultVideoUrl = 'https://media.hidreamai.com/';

export function GetQueryString(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}


export function masterUrl(url, checkType = false) {
  if (!url) return ''
  let ext = '.jpg'
  if (checkType) {
    ext = url.indexOf('p_') > -1 ? '.png' : '.jpg'
  }
  return defaultUrl + url + ext;
}
/**
 * 获取图片url
 * @export
 * @param {*} url
 * @param {number} [width=512]
 * @param {boolean} [ext=false] 是否显示原本后缀
 * @return {*} 
 */
export function changeUrl(url, ext = false) {
  if (!url) return ''
  let finalUrl = "";
  if (url.indexOf(defaultUrl) !== -1) {
    if (url.indexOf(".jpg") !== -1) {
      let ipo = url.indexOf(".jpg");
      finalUrl = url.substring(0, ipo).replace(defaultUrl, "");
    }
    if (url.indexOf(".png") !== -1) {
      // 说明存在后缀，需要去除
      let ipo = url.indexOf(".png");
      finalUrl = url.substring(0, ipo).replace(defaultUrl, "");
    }
    // 说明存在域名，转为不存在的
  } else {
    // 需要添加域名及后缀
    let imageUrl = masterUrl(url, ext)
    finalUrl = imageUrl;
  }
  return finalUrl;
}

export function publishMg(params) {
  const uid = sessionStorage.getItem('uid') ?? ''
  const secret = sessionStorage.getItem('secret') ?? ''
  const watermarkId = sessionStorage.getItem('watermarkId') ?? ''
  const projectId = sessionStorage.getItem('projectId') ?? ''
  const otherSet = sessionStorage.getItem('otherSet') ?? ''
  const releaseId = sessionStorage.getItem('releaseId') ?? ''
  const isMiniPublish = sessionStorage.getItem('isMiniPublish') ?? ''
  const url = `https://y.migu.cn/app/v5/p/publish-mid/index.html?videoUrl=${encodeURIComponent(params.video)}&videoCover=${encodeURIComponent(params.cover)}&uid=${uid}&secret=${secret}&watermarkId=${watermarkId}&projectId=${projectId}&otherSet=${otherSet}&releaseId=${releaseId}&isMiniPublish=${isMiniPublish}`
  window.location.href = url
}
export function fakeProgressBar(duration, callback) {
  const steps = duration; // 总更新次数
  const interval = 1000; // 每秒更新一次
  let currentStep = 0; // 当前步骤
  let progress = 0; // 当前进度

  const timer = setInterval(() => {
      currentStep++;

      // 随机生成进度增量，确保进度递增并最终达到 1
      const remainingSteps = steps - currentStep;
      const increment = remainingSteps > 0
          ? Math.random() * (1 - progress) / remainingSteps // 根据剩余步数动态调整增量范围
          : 1 - progress; // 最后一步直接达到 1

      progress = Math.min(progress + increment, 1); // 确保 progress 不超过 1

      // 调用回调函数，传递当前进度
      callback(progress);

      // 如果达到最大步数，清除定时器
      if (currentStep >= steps || progress >= 1) {
          clearInterval(timer);
      }
  }, interval);
}